module.exports = __webpack_public_path__ + "static/media/tumblr.806c1266.svg";